import React, { useState, useEffect } from "react";
import { Card, Row, Col, Flex, Button, Form, Input, Select, Divider, Tag, Tooltip } from 'antd';
import { InfoCircleOutlined, TruckOutlined, ShoppingOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { API } from '../components/Initilization'
import { useNotificationContext } from '../components/NotificationContext'
import { IRAN_PROVINCES } from '../constants/provinces'
import "../assets/css/contact-us.css"

const { Option } = Select;
const SHIPPING_COST = 150000; // 150,000 Tomans
const FREE_SHIPPING_THRESHOLD = 2000000; // 2,000,000 Tomans

const CheckOut = () => {
  const [form] = Form.useForm();
  const [productsTotalPrice, setProductsTotalPrice] = useState(0);
  const [shippingCost, setShippingCost] = useState(SHIPPING_COST);
  const [vatAmount, setVatAmount] = useState(0);
  const [finalTotal, setFinalTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [designedOrders, setDesignedOrders] = useState(
    JSON.parse(localStorage.getItem('designedOrders')) != null 
      ? JSON.parse(localStorage.getItem('designedOrders')) 
      : []
  );
  const [regularCart, setRegularCart] = useState(
    JSON.parse(localStorage.getItem('cart')) != null 
      ? JSON.parse(localStorage.getItem('cart')) 
      : []
  );
  const notif = useNotificationContext();
  const navigate = useNavigate();

  useEffect(() => {
    CalculateCartTotalPrice();
    GetUsername();
  }, []);

  const CalculateCartTotalPrice = () => {
    let ProductsTotal = 0;
    
    if (designedOrders.length > 0) {
      designedOrders.forEach((item) => {
        ProductsTotal = ProductsTotal + (item.Amount * item.UnitPrice) + 
          (parseInt(JSON.parse(item.AdditionalDesignImage || '[]').length) * 60000)
      });
    }
    
    if (regularCart.length > 0) {
      regularCart.forEach((item) => {
        ProductsTotal = ProductsTotal + (item.price * item.quantity)
      });
    }
    
    setProductsTotalPrice(ProductsTotal);
    
    // Calculate shipping based on products total
    if (ProductsTotal >= FREE_SHIPPING_THRESHOLD) {
      setShippingCost(0);
    } else {
      setShippingCost(SHIPPING_COST);
    }
  };

  useEffect(() => {
    // Calculate VAT (10% on products total only)
    const vat = Math.floor(productsTotalPrice * 0.1);
    setVatAmount(vat);
    setFinalTotal(productsTotalPrice + vat + shippingCost);
  }, [productsTotalPrice, shippingCost]);

  const GetUsername = () => {
    API.get('/api/account/get-username', { NeedsAuthorization: true })
      .then(function (response) {
        if (response.status === 200 && response.data.ResultCode === 200) {
          form.setFieldsValue({
            MobileNumber: response.data.Obj
          });
        }
      })
      .catch((error) => {
        console.log(error);
        notif.open({
          type: 'error',
          style: { width: "450px" },
          className: "fYekan-bold",
          placement: 'topRight',
          message: 'خطا',
          description: 'خطا در دریافت اطلاعات کاربری',
        });
      });
  };

  const handleCreateOrder = async (values) => {
    setLoading(true);
    
    try {
      const designedOrdersData = designedOrders.map(order => ({
        ProductName: order.ProductName,
        ProductColor: order.ProductColor,
        ProductSize: order.ProductSize,
        ProductQuality: order.ProductQuality,
        FirstDesignPic: order.FirstDesignPic,
        SecondDesignPic: order.SecondDesignPic || "",
        Amount: order.Amount,
        UnitPrice: order.UnitPrice,
        AdditionalDesignImage: order.AdditionalDesignImage || "[]"
      }));
      
      const regularOrdersData = regularCart.map(item => ({
        product_slug: item.productSlug,
        quantity: item.quantity
      }));
      
      const bodyFormData = new FormData();
      bodyFormData.append("FullName", values.FullName);
      bodyFormData.append("Province", values.Province);
      bodyFormData.append("City", values.City);
      bodyFormData.append("PostalCode", values.PostalCode);
      bodyFormData.append("DeliveryAddress", values.DeliveryAddress);
      bodyFormData.append("Description", values.Description || "");
      bodyFormData.append("OrderableOrders", JSON.stringify(regularOrdersData));
      bodyFormData.append("DesignedOrders", JSON.stringify(designedOrdersData));
      bodyFormData.append("ShippingCost", shippingCost);

      const response = await API.post('/api/order/create-purchase', bodyFormData, { 
        NeedsAuthorization: true 
      });

      if (response.status === 200 && response.data.ResultCode === 200) {
        const orderData = response.data.Obj;
        const orderId = orderData.order_id;
        const totalPrice = finalTotal;
        
        await handlePaymentRequest(orderId, totalPrice);
      } else {
        notif.open({
          type: 'error',
          style: { width: "450px" },
          className: "fYekan-bold",
          placement: 'topRight',
          message: 'خطا',
          description: response.data.ResultMessage || 'خطا در ثبت سفارش',
        });
        setLoading(false);
      }
    } catch (error) {
      console.error('Order creation error:', error);
      notif.open({
        type: 'error',
        style: { width: "450px" },
        className: "fYekan-bold",
        placement: 'topRight',
        message: 'خطا',
        description: 'خطا در ثبت سفارش. لطفاً دوباره تلاش کنید',
      });
      setLoading(false);
    }
  };

  const handlePaymentRequest = async (orderId, totalPrice) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append('Amount', totalPrice);
      bodyFormData.append('Description', "خرید محصول از آقای چاپ");
      bodyFormData.append('Type', "1");

      const response = await API.post('/api/payment/request', bodyFormData, {
        NeedsAuthorization: true
      });

      if (response.status === 200 && response.data.status) {
        sessionStorage.setItem('currentOrderId', orderId);
        sessionStorage.setItem('paymentAuthority', response.data.authority);
        window.location.href = response.data.url;
      } else {
        notif.open({
          type: 'error',
          style: { width: "450px" },
          className: "fYekan-bold",
          placement: 'topRight',
          message: 'خطا',
          description: response.data.message || 'خطا در اتصال به درگاه پرداخت',
        });
        setLoading(false);
      }
    } catch (error) {
      console.error('Payment request error:', error);
      notif.open({
        type: 'error',
        style: { width: "450px" },
        className: "fYekan-bold",
        placement: 'topRight',
        message: 'خطا',
        description: 'خطا در اتصال به درگاه پرداخت',
      });
      setLoading(false);
    }
  };

  const onFinish = (values) => {
    if ((!designedOrders || designedOrders.length === 0) && (!regularCart || regularCart.length === 0)) {
      notif.open({
        type: 'warning',
        style: { width: "450px" },
        className: "fYekan-bold",
        placement: 'topRight',
        message: 'هشدار',
        description: 'سبد خرید شما خالی است',
      });
      return;
    }
    handleCreateOrder(values);
  };

  const validationRules = {
    FullName: [
      { required: true, message: 'لطفاً نام و نام خانوادگی را وارد کنید' },
      { min: 3, message: 'نام و نام خانوادگی باید حداقل ۳ کاراکتر باشد' },
    ],
    Province: [{ required: true, message: 'لطفاً استان را انتخاب کنید' }],
    City: [{ required: true, message: 'لطفاً شهر را وارد کنید' }],
    PostalCode: [
      { required: true, message: 'لطفاً کد پستی را وارد کنید' },
      { pattern: /^\d{10}$/, message: 'کد پستی باید ۱۰ رقم باشد' },
    ],
    DeliveryAddress: [
      { required: true, message: 'لطفاً آدرس را وارد کنید' },
      { min: 10, message: 'آدرس باید حداقل ۱۰ کاراکتر باشد' },
    ],
  };

  const isFreeShipping = productsTotalPrice >= FREE_SHIPPING_THRESHOLD;

  return (
    <Row align={"center"}>
      <Col span={24} style={{ maxWidth: "1200px" }}>
        <Card className="fYekan light-glass-effect-card shaped-border" title="تایید سفارش">
          
          {/* Shipping Info Banner */}
          <div style={{ 
            background: isFreeShipping ? 'rgba(82, 196, 26, 0.1)' : 'rgba(250, 173, 20, 0.1)',
            padding: '12px 16px',
            borderRadius: 12,
            marginBottom: 24,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            borderRight: `3px solid ${isFreeShipping ? '#2b8200' : 'rgb(166, 110, 0)'}`
          }}>
            <TruckOutlined style={{ fontSize: 24, color: isFreeShipping ? '#2b8200' : 'rgb(166, 110, 0)' }} />
            <div>
              {isFreeShipping ? (
                <span style={{ color: '#2b8200' }}>
                  🎉 مبلغ خرید شما از {FREE_SHIPPING_THRESHOLD.toLocaleString()} تومان بیشتر است!
                  هزینه ارسال برای شما <strong>رایگان</strong> می‌باشد.
                </span>
              ) : (
                <span style={{ color: 'rgb(166, 110, 0)' }}>
                   برای بهره‌مندی از ارسال رایگان، حداقل {FREE_SHIPPING_THRESHOLD.toLocaleString()} تومان سفارش دهید.
                  <br />
                  <small>(هزینه ارسال: {SHIPPING_COST.toLocaleString()} تومان)</small>
                </span>
              )}
            </div>
          </div>

          <Flex className="fEstedad" align="center" justify="center">
            <Row gutter={[24, 0]} style={{ alignItems: 'stretch' }}>
              
              {/* Form Section - Always visible on all screen sizes */}
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form 
                  form={form}
                  style={{ width: "100%" }} 
                  layout="vertical"
                  onFinish={onFinish}
                  autoComplete="off"
                >
                  <Row gutter={[24, 0]}>
                    <Col xs={24} lg={12}>
                      <Form.Item label="نام و نام خانوادگی" name="FullName" rules={validationRules.FullName}>
                        <Input placeholder="نام و نام خانوادگی خود را وارد کنید" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item label="شماره همراه" name="MobileNumber">
                        <Input disabled style={{ direction: "ltr", height:"40px", paddingTop:"0px" }} prefix={<p style={{ marginTop:"22px" }}> +98 </p> } />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item label="استان" name="Province" rules={validationRules.Province}>
                        <Select 
                        style={{height:"40px"}}
                          placeholder="استان خود را انتخاب کنید" 
                          showSearch
                          optionFilterProp="children"
                        >
                          {IRAN_PROVINCES.map(province => (
                            <Option key={province.id} value={province.name}>{province.name}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item label="شهر" name="City" rules={validationRules.City}>
                        <Input placeholder="شهر خود را وارد کنید" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item 
                        label="کد پستی" 
                        name="PostalCode" 
                        rules={validationRules.PostalCode}
                        tooltip="کد پستی ۱۰ رقمی خود را وارد کنید"
                      >
                        <Input placeholder="کد پستی ۱۰ رقمی را وارد کنید" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={24}>
                      <Form.Item 
                        label="آدرس" 
                        name="DeliveryAddress" 
                        rules={validationRules.DeliveryAddress}
                      >
                        <Input.TextArea rows={2} placeholder="آدرس کامل خود را وارد کنید (پلاک، واحد، کوچه، ...)" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={24}>
                      <Form.Item 
                        label="توضیحات" 
                        name="Description"
                      >
                        <Input.TextArea rows={2} placeholder="توضیحات اضافه (اختیاری)" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>

              {/* Desktop/Large Screen Factor Section - Only visible on lg and xl screens */}
              <Col xs={0} sm={0} md={0} lg={12} xl={12}>
                <Row className="pt-3" gutter={[24, 0]}>
                  <Col align="center" className='mb-3' lg={11}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>هزینه ارسال</div>
                    <div className='font-4' style={{ marginTop: "10px" }}>
                      {shippingCost === 0 ? 'رایگان' : shippingCost.toLocaleString() + ' تومان'}
                    </div>
                  </Col>
                  <Col align="center" className='mb-3' lg={2}>
                    <div style={{ marginTop: "12px", fontSize: "30px" }}> + </div>
                  </Col>
                  <Col align="center" className='mb-3' lg={11}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>مالیات (10%)</div>
                    <div className='font-4' style={{ marginTop: "10px" }}>
                      {vatAmount.toLocaleString()} تومان
                    </div>
                  </Col>
                  <Col align="center" className='mb-3' lg={2}>
                    <div style={{ marginTop: "12px", fontSize: "30px" }}> + </div>
                  </Col>
                  <Col align="center" className='mb-3' lg={11}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>هزینه اجناس و طراحی</div>
                    <div className='font-4' style={{ marginTop: "10px" }}>
                      {productsTotalPrice.toLocaleString()} تومان
                    </div>
                  </Col>
                  <Col align="center" className='mb-3' lg={24}>
                    <div style={{ marginTop: "12px", fontSize: "30px" }}> = </div>
                  </Col>
                  <Col align="center" className='mb-3' lg={22} offset={1}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>قابل پرداخت</div>
                    <div className='font-4' style={{ marginTop: "10px", fontSize: 24, color: '#a23854', fontWeight: 'bold' }}>
                      {finalTotal.toLocaleString()} تومان
                    </div>
                  </Col>

                  <Col lg={24} className="mt-4"></Col>
                  <Row gutter={[24, 24]} style={{ margin: '0 auto' }}>
                    <Col align={"center"} lg={12}>
                      <Link to="/cart">
                        <Button color="text" variant="outlined">مدیریت سبد خرید</Button>
                      </Link>
                    </Col>
                    <Col align={"center"} lg={12}>
                      <Button 
                        onClick={() => form.submit()} 
                        type="primary" 
                        loading={loading}
                        style={{ minWidth: 160 }}
                      >
                        تایید سفارش و پرداخت
                      </Button>
                    </Col>
                  </Row>
                </Row>
              </Col>

              {/* Mobile Factor Section - Only visible on xs, sm, and md screens */}
              <Col xs={24} sm={24} md={24} lg={0} xl={0}>
                <Row gutter={[24, 0]}>
                  <Col className="pt-5" align="center" span={24}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>هزینه اجناس و طراحی</div>
                    <div className='font-4' style={{ marginTop: "10px" }}>
                      {productsTotalPrice.toLocaleString()} تومان
                    </div>
                  </Col>
                  <Col align="center" span={24}>
                    <div style={{ marginTop: "12px", fontSize: "30px" }}> + </div>
                  </Col>
                  <Col align="center" span={24}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>مالیات (10%)</div>
                    <div className='font-4' style={{ marginTop: "10px" }}>
                      {vatAmount.toLocaleString()} تومان
                    </div>
                  </Col>
                  <Col align="center" span={24}>
                    <div style={{ marginTop: "12px", fontSize: "30px" }}> + </div>
                  </Col>
                  <Col align="center" span={24}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>هزینه ارسال</div>
                    <div className='font-4' style={{ marginTop: "10px" }}>
                      {shippingCost === 0 ? 'رایگان' : shippingCost.toLocaleString() + ' تومان'}
                    </div>
                  </Col>
                  <Col align="center" span={24}>
                    <div style={{ marginTop: "12px", fontSize: "30px" }}> = </div>
                  </Col>
                  <Col align="center" span={24}>
                    <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>قابل پرداخت</div>
                    <div className='font-4' style={{ marginTop: "10px", fontSize: 20, color: '#a23854', fontWeight: 'bold' }}>
                      {finalTotal.toLocaleString()} تومان
                    </div>
                  </Col>

                  <Col span={24} className="mt-4"></Col>
                  <Row gutter={[24, 24]} style={{ margin: '0 auto' }}>
                    <Col align={"center"} span={24}>
                      <Link to="/cart">
                        <Button color="text" variant="outlined">مدیریت سبد خرید</Button>
                      </Link>
                    </Col>
                    <Col align={"center"} span={24}>
                      <Button onClick={() => form.submit()} type="primary" loading={loading}>
                        تایید سفارش و پرداخت
                      </Button>
                    </Col>
                  </Row>
                </Row>
              </Col>

            </Row>
          </Flex>
        </Card>
      </Col>
    </Row>
  );
};

export default CheckOut;